module.exports = __webpack_public_path__ + "img/film.7ad21532.png";